type EnvType = {
  API_BASE_URL: string;
  API_OLD_BASE_URL: string;
  OLD_FRONTEND_URL: string;
  FRONTEND_URL: string;
  CURRENT_ENV_MODE: "development" | "local" | "production";
};

export const env: EnvType = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  API_OLD_BASE_URL: import.meta.env.VITE_API_OLD_BASE_URL,
  OLD_FRONTEND_URL: import.meta.env.VITE_OLD_FRONTEND_URL,
  FRONTEND_URL: import.meta.env.VITE_FRONTEND_URL,
  CURRENT_ENV_MODE: import.meta.env.VITE_NODE_ENV,
};
